"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: {
            display: 'flex',
            width: '400px',
            margin: '0px auto',
        },
        calendarIcon: {
            paddingLeft: '25px',
            paddingRight: '5px',
        },
        calendarImage: {
            cursor: 'pointer',
        },
        decrementWeekButton: {
            paddingTop: '12px',
            paddingLeft: '24px',
        },
        incrementWeekButton: {
            paddingTop: '12px',
            paddingRight: '24px',
        },
        text: {
            fontWeight: 'bold',
            borderBottom: '2px',
            borderBottomStyle: 'solid',
            borderBottomColor: '#5d89ad',
            paddingTop: '12px',
        },
        alignAndJustify: {
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        datePicker: {
            display: 'flex',
            position: 'absolute',
            left: '38%',
            boxShadow: '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
            zIndex: 3,
        },
    });
});
